import api from '@/helpers/fetch'

export default {
	state: {
		initials: null,
		//
		selectedInitialId: null,
		//
		elaboratorId: null,
		elaboratorById: {},
		elaboratorByIdArray: [],
		//
		reviewerId: null,
		reviewerById: {},
		reviewerByIdArray: [],
		//
		fields: null,
		initialsById: {},
	},
	mutations: {
		SET_RESPONSIBLE_ID(
			state: any,
			payload: { elaboratorId: any; reviewerId: any },
		): void {
			state.elaboratorId = payload.elaboratorId
			state.reviewerId = payload.reviewerId
		},
		SET_FIELDS(state, fields) {
			state.fields = fields
		},
		ADD_INITIALS(state, initials) {
			state.initials = initials
		},
		PROCESS_INITIALS(state) {
			processInitials(state)
		},
		SET_SELECTED_INITIAL_ID(state, id) {
			state.selectedInitialId = id
		},
	},
	actions: {
		fetchInitials: async function (context, options): Promise<void> {
			const res = await api.get('/api/initial-management')

			const initials = res?.data
			const fields = res?.fields

			context.commit('ADD_INITIALS', initials)
			context.commit('SET_FIELDS', fields)
			context.commit('PROCESS_INITIALS')
		},
		filterInitials: async function (context, options): Promise<void> {
			const res = await api.get(
				`/api/initial-management/${options.elaborator_user_id}/${options.reviewer_user_id}`,
			)
			const initials = res?.data
			const fields = res?.fields
			const payload = {
				elaboratorId: options.elaborator_user_id,
				reviewerId: options.reviewer_user_id,
			}

			context.commit('ADD_INITIALS', initials)
			context.commit('SET_FIELDS', fields)
			context.commit('PROCESS_INITIALS')

			context.commit('SET_RESPONSIBLE_ID', payload)
		},
		createInitial: async function (context): Promise<void> {
			const res = await api.post('/api/initial-management/new', {})
			return res
		},
		selectInitialId: async function (context, id): Promise<void> {
			context.commit('SET_SELECTED_INITIAL_ID', id)
		},
		saveInitial: async function (context, initial): Promise<void> {
			const res = await api.put('/api/initial-management', initial)
			return res
		},
	},
}

function processInitials(state) {
	const initials = state.initials

	state.initialsById = {}

	initials.forEach((initial) => {
		state.initialsById[initial.id] = initial

		const elaborator = initial?.elaborator
		if (elaborator) {
			state.elaboratorById[elaborator.id] =
				state.elaboratorById[elaborator.id] || elaborator
		}

		const reviewer = initial?.reviewer
		if (reviewer) {
			state.reviewerById[reviewer.id] =
				state.reviewerById[reviewer.id] || reviewer
		}
	})

	state.elaboratorByIdArray = Object.keys(state.elaboratorById)
	state.reviewerByIdArray = Object.keys(state.reviewerById)
}
